import classNames from 'classnames';
import React from 'react';
import Typography from '../../../typography/typography';
import { useFormSettingsContext } from '../../Form.context';
import { FormSectionSC, sectionClasses } from './form-section.styled';

interface FormSectionProps
  extends Omit<
    React.DetailedHTMLProps<React.FieldsetHTMLAttributes<HTMLFieldSetElement>, HTMLFieldSetElement>,
    'ref'
  > {
  label: string;
  size?: 'large' | 'small';
  description?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  extra?: React.ReactNode;
}

const FormSection: React.FunctionComponent<FormSectionProps> = ({
  children,
  label,
  style,
  className,
  extra,
  disabled,
  description,
  size = 'large',
  ...rest
}) => {
  const settings = useFormSettingsContext({ disabled });

  return (
    <FormSectionSC
      {...rest}
      style={style}
      className={classNames(
        sectionClasses.wrapper,
        `${sectionClasses.wrapper}-${size}`,
        !!description ? `${sectionClasses.wrapper}-description` : null,
        className,
      )}
      disabled={settings.disabled}
    >
      <div className={sectionClasses.header}>
        <Typography display="body1" variant="strong" as="div" className={sectionClasses.title}>
          {label}
        </Typography>
        {extra ? <div className={sectionClasses.extra}>{extra}</div> : null}
      </div>
      {description ? (
        <Typography display="body2" variant="default" className={sectionClasses.description}>
          {description}
        </Typography>
      ) : null}
      {children}
    </FormSectionSC>
  );
};

export default FormSection;
